<template>
  <div class="index_content">
    <div class="link">
      <ul class="bootom_ul">
        <li v-for="item in url3" :key="item.url_id"><a :href="item.url_path" target="_blank">{{item.url_name}}</a></li>
      </ul>
    </div>
    <div class="banner_content">
      <div class="banner">
        <!-- 轮播图 -->
        <div class="banner_left">
          <el-carousel :interval="5000" :height="bannerHeight" arrow="always">
            <el-carousel-item v-for="item in bannerList" :key="item.news_id">
              <el-image :src="imgPath + item.news_img_path" @click="details(item.news_id)" fit="cover"></el-image>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="banner_right">
          <ul>
            <li v-for="item in guoNeiNewsList" :key="item.news_id" @click="details(item.news_id)">
              <h3>{{ item.news_art_title }}</h3>
              <p></p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="content_content">
      <!-- 左侧要闻 -->
      <div class="content_left">
        <h2><span @click="tomore(9)">省内新闻</span></h2>
        <ul class="newlist">
          <li v-for="item in shengNeiNewsList" :key="item.news_id" @click="details(item.news_id)">
            <h3>{{ item.news_art_title }}</h3>
          </li>
        </ul>
        <h2 style="margin-top:60px;"><span @click="tomore(9)">本地新闻</span></h2>
        <ul class="newlist">
          <li v-for="item in benShiNewsList" :key="item.news_id" @click="details(item.news_id)">
            <h3>{{ item.news_art_title }}</h3>
          </li>
        </ul>
      </div>
      <!-- 右侧图片视频 -->
      <div class="content_right">
        <h2><span>专题集锦</span></h2>
        <a v-for="item in zhuantiList" :key="item.special_id" :href="item.special_url" target="_black" class="right_a">
          <el-image :src="imgPath + item.special_img_path" fit="cover"></el-image>
        </a>
      </div>
    </div>
    <!-- 工作动态 -->
    <div class="quanwei2">
      <h2>工作动态</h2>
      <div class="quanwei_n">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick" class="tabss">
          <el-tab-pane v-if="gongzuoTitleList[0] !==undefined" :label="gongzuoTitleList[0].column_name" name="label1">
            <ul class="bootom_ul">
              <li v-for="item in gongzuo1" :key="item.news_id" @click="details(item.news_id)">{{item.news_art_title}}</li>
            </ul>
          </el-tab-pane>
          <el-tab-pane v-if="gongzuoTitleList[1] !==undefined" :label="gongzuoTitleList[1].column_name" name="label2">
            <ul class="bootom_ul">
              <li v-for="item in gongzuo2" :key="item.news_id" @click="details(item.news_id)">{{item.news_art_title}}</li>
            </ul>
          </el-tab-pane>
          <el-tab-pane v-if="gongzuoTitleList[2] !==undefined" :label="gongzuoTitleList[2].column_name" name="label3">
            <ul class="bootom_ul">
              <li v-for="item in gongzuo3" :key="item.news_id" @click="details(item.news_id)">{{item.news_art_title}}</li>
            </ul>
          </el-tab-pane>
          <el-tab-pane v-if="gongzuoTitleList[3] !==undefined" :label="gongzuoTitleList[3].column_name" name="label4">
            <ul class="bootom_ul">
              <li v-for="item in gongzuo4" :key="item.news_id" @click="details(item.news_id)">{{item.news_art_title}}</li>
            </ul>
          </el-tab-pane>
          <el-tab-pane v-if="gongzuoTitleList[4] !==undefined" :label="gongzuoTitleList[4].column_name" name="label5">
            <ul class="bootom_ul">
              <li v-for="item in gongzuo5" :key="item.news_id" @click="details(item.news_id)">{{item.news_art_title}}</li>
            </ul>
          </el-tab-pane>
          <el-tab-pane v-if="gongzuoTitleList[5] !==undefined" :label="gongzuoTitleList[5].column_name" name="label6">
            <ul class="bootom_ul">
              <li v-for="item in gongzuo6" :key="item.news_id" @click="details(item.news_id)">{{item.news_art_title}}</li>
            </ul>
          </el-tab-pane>
          <el-tab-pane v-if="gongzuoTitleList[6] !==undefined" :label="gongzuoTitleList[6].column_name" name="label7">
            <ul class="bootom_ul">
              <li v-for="item in gongzuo7" :key="item.news_id" @click="details(item.news_id)">{{item.news_art_title}}</li>
            </ul>
          </el-tab-pane>
          <el-tab-pane v-if="gongzuoTitleList[7] !==undefined" :label="gongzuoTitleList[7].column_name" name="label8">
            <ul class="bootom_ul">
              <li v-for="item in gongzuo8" :key="item.news_id" @click="details(item.news_id)">{{item.news_art_title}}</li>
            </ul>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <!-- 权威发布 -->
    <div class="quanwei">
      <h2>权威发布</h2>
      <div class="quanwei_n">
        <div class="quanei_block">
          <h4 v-if="quanweiTitleList[0] !==undefined">{{ quanweiTitleList[0].column_name }}<span @click="tomore(quanweiTitleList[0].column_id)">更多 ></span></h4>
          <ul>
            <li v-for="item in quanweiList1" :key="item.news_id" @click="details(item.news_id)">{{ item.news_art_title }}</li>
          </ul>
        </div>
        <div class="quanei_block">
          <h4 v-if="quanweiTitleList[1] !==undefined">{{ quanweiTitleList[1].column_name }}<span @click="tomore(quanweiTitleList[1].column_id)">更多 ></span></h4>
          <ul>
            <li v-for="item in quanweiList2" :key="item.news_id" @click="details(item.news_id)">{{ item.news_art_title }}</li>
          </ul>
        </div>
        <div class="quanei_block">
          <h4 v-if="quanweiTitleList[2] !==undefined">{{ quanweiTitleList[2].column_name }}<span @click="tomore(quanweiTitleList[2].column_id)">更多 ></span></h4>
          <ul>
            <li v-for="item in quanweiList3" :key="item.news_id" @click="details(item.news_id)">{{ item.news_art_title }}</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="content_content">
      <!-- 廉政清风 -->
      <div class="content_left">
        <h2><span>廉政清风</span></h2>
        <ul class="lzqf">
          <li v-for="item in lzqfvideo" :key="item.img_id" @click="videos(item.img_name,item.img_path)">
            <el-image :src="imgPath + item.img_title"  fit="cover"></el-image>
            <p>{{ item.img_name }}</p>
          </li>
          <li v-for="item in lzqfimg" :key="item.news_id" @click="details(item.news_id)">
            <el-image :src="imgPath + item.news_img_path"  fit="cover"></el-image>
            <p>{{ item.news_art_title }}</p>
          </li>
        </ul>
      </div>
      <el-dialog
        :title="videotitle"
        :visible.sync="dialogVisible"
        width="60%"
        :before-close="handleClose">
        <video :src="videoUrl" controls autoplay class="video" width="100%"></video>
      </el-dialog>
      <!-- 信访举报 -->
      <div class="content_right" style="width:610px;">
        <h2><span>信访举报</span></h2>
        <div class="report_n">
          <div class="img">
            <a href="http://liaoning.12388.gov.cn/tieling/" target="_black"><img src="@/assets/images/img_3.jpg"/></a>
            <a href="http://www.lnsjjjc.gov.cn/wzsy/jbzn.html" target="_black"><img src="@/assets/images/img_4.jpg"/></a>
            <a href="http://liaoning.12388.gov.cn/tieling/html/jb_seach.html" target="_black"><img src="@/assets/images/img_5.jpg"/></a>
          </div>
          <div class="text">
            <p>举报电话：<br/>{{report.report_tel}}</p>
            <p>举报网址：<br/><a :href="report.report_web" target="_black">{{report.report_web}}</a></p>
            <p>来信请寄：<br/>{{report.report_em}}</p>
            <p style="margin-bottom:0;">来访接待地址：<br/>{{report.report_add}}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 专题集萃 -->
    <div class="zhuanti">
      <h2>专题集萃</h2>
      <div class="zhuanti_n">
        <a v-for="item in jicueiList" :key="item.special_id" :href="item.special_url" target="_black">
          <el-image :src="imgPath + item.special_img_path" fit="cover"></el-image>
        </a>
      </div>
    </div>
    <!-- 友情链接 -->
    <div class="geturl">
      <h2>友情链接</h2>
      <div class="geturl_n">
        <div class="geturl_n_1" @click="show1=true"  @mouseleave="show1=false">
          党中央部门机构<i class="el-icon-arrow-up el-icon--right"></i>
          <div class="bott" v-show="show1">
            <a v-for="item in url1" :key="item.url_id" :href="item.url_path" target="_blank">{{item.url_name}}</a>
          </div>
        </div>
        <div class="geturl_n_1" @click="show2=true"  @mouseleave="show2=false">
          国务院机构<i class="el-icon-arrow-up el-icon--right"></i>
          <div class="bott" v-show="show2">
            <a v-for="item in url2" :key="item.url_id" :href="item.url_path" target="_blank">{{item.url_name}}</a>
          </div>
        </div>
        <div class="geturl_n_1" @click="show3=true"  @mouseleave="show3=false">
          派驻纪检监察机构<i class="el-icon-arrow-up el-icon--right"></i>
          <div class="bott" v-show="show3">
            <a v-for="item in url4" :key="item.url_id" :href="item.url_path" target="_blank">{{item.url_name}}</a>
          </div>
        </div>
        <div class="geturl_n_1" @click="show4=true"  @mouseleave="show4=false">
          新闻媒体<i class="el-icon-arrow-up el-icon--right"></i>
          <div class="bott" v-show="show4">
            <a v-for="item in url5" :key="item.url_id" :href="item.url_path" target="_blank">{{item.url_name}}</a>
          </div>
        </div>
        <div class="geturl_n_1" @click="show5=true"  @mouseleave="show5=false">
          本市各机关网站<i class="el-icon-arrow-up el-icon--right"></i>
          <div class="bott" v-show="show5">
            <a v-for="item in url6" :key="item.url_id" :href="item.url_path" target="_blank">{{item.url_name}}</a>
          </div>
        </div>
        <div class="geturl_n_1" @click="show6=true"  @mouseleave="show6=false">
          新闻媒体网站<i class="el-icon-arrow-up el-icon--right"></i>
          <div class="bott" v-show="show6">
            <a v-for="item in url7" :key="item.url_id" :href="item.url_path" target="_blank">{{item.url_name}}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
  import '@/assets/css/style.css'
  import {imgPath,cityId,keywords,description,metatitle,SiteName,SiteDomain} from "@/api/api"
  export default {
    name: 'index',
    data() {
      return {
        imgPath,
        cityId,
        bannerList:[],
        bannerHeight: '364px',
        benShiNewsList:[],
        guoNeiNewsList:[],
        shengNeiNewsList:[],
        zhuantiList:[],
        jicueiList:[],
        quanweiTitleList:[],
        quanweiList1:[],
        quanweiList2:[],
        quanweiList3:[],
        quanweiList4:[],
        columnId:10,
        report:[],
        url1:[],
        url2:[],
        url3:[],
        url4:[],
        url5:[],
        url6:[],
        url7:[],
        gongzuoTitleList:[],
        gongzuo1:[],
        gongzuo2:[],
        gongzuo3:[],
        gongzuo4:[],
        gongzuo5:[],
        gongzuo6:[],
        gongzuo7:[],
        gongzuo8:[],
        activeName:"label1",
        lzqfvideo:[],
        lzqfimg:[],
        dialogVisible: false,
        videoUrl:"",
        videotitle:"",
        show1:false,
        show2:false,
        show3:false,
        show4:false,
        show5:false,
        show6:false,
      }
    },
    metaInfo(){
      return{
        title:metatitle,
        meta:[
          {name:'keywords',content:keywords},
          {name:"description",content:description},
          {name:"SiteName",content:SiteName},
          {name:"SiteDomain",content:SiteDomain},
          {name:"SiteIDCode",content:"辽ICP备16006427号-2"}
        ]
      }
    },
    created(){
      this.httpPost();
    },
    methods:{
      httpPost(){
        const _this = this;
        //要闻
        this.$http({
          headers:"application/json; charset=utf-8",
          url: "/api/Index/GetNewsList",
          data:{"city_id":cityId},
          success(res){
            _this.guoNeiNewsList = res.extend.guoNeiNewsList;
            _this.shengNeiNewsList = res.extend.shengNeiNewsList;
            _this.benShiNewsList = res.extend.benShiNewsList;
          }
        });
        //友情链接
        this.$http({
          headers:"application/json; charset=utf-8",
          url: "/api/Index/GetUrl",
          data:{"city_id":cityId},
          success(res){
            _this.url1 = res.extend.url1;
            _this.url2 = res.extend.url2;
            _this.url3 = res.extend.url3;
            _this.url4 = res.extend.url4;
            _this.url5 = res.extend.url5;
            _this.url6 = res.extend.url6;
            _this.url7 = res.extend.url7;
          }
        });
        //举报
        this.$http({
          headers:"application/json; charset=utf-8",
          url: "/api/Report/SelectReport",
          data:{"city_id":cityId},
          success(res){
            _this.report = res.extend.report;
          }
        });
        //工作动态
        this.$http({
          headers:"application/json; charset=utf-8",
          url: "/api/Index/GetGzdt",
          data:{"city_id":cityId},
          success(res){
            _this.gongzuoTitleList = res.extend.module_list;
            _this.gongzuo1 = res.extend.list1;
            _this.gongzuo2 = res.extend.list2;
            _this.gongzuo3 = res.extend.list3;
            _this.gongzuo4 = res.extend.list4;
            _this.gongzuo5 = res.extend.list5;
            _this.gongzuo6 = res.extend.list6;
            _this.gongzuo7 = res.extend.list7;
            _this.gongzuo8 = res.extend.list8;
          }
        });
        //权威发布
        this.$http({
          headers:"application/json; charset=utf-8",
          url: "/api/Index/GetQwfb",
          data:{"city_id":cityId},
          success(res){
            _this.quanweiTitleList = res.extend.module_list;
            _this.quanweiList1 = res.extend.list1;
            _this.quanweiList2 = res.extend.list2;
            _this.quanweiList3 = res.extend.list3;
            _this.quanweiList4 = res.extend.list4;
            //轮播图
            _this.$http({
              headers:"application/json; charset=utf-8",
              url: "/api/Index/GetBanner",
              data:{"city_id":cityId},
              success(res){
                _this.bannerList = res.extend.banner_list;
              }
            });
            //廉政清风
            _this.$http({
              headers:"application/json; charset=utf-8",
              url: "/api/Index/Getlzqf",
              data:{"city_id":cityId},
              success(res){
                _this.lzqfimg = res.extend.img_list;
                _this.lzqfvideo = res.extend.video_list;
              }
            });
            //专题
            _this.$http({
              headers:"application/json; charset=utf-8",
              url: "/api/Index/GetSpecial",
              data:{"city_id":cityId},
              success(res){
                _this.zhuantiList = res.extend.ztjj_list;
                _this.jicueiList = res.extend.ztjc_list;
              }
            });
          }
        });
      },
      handleClick(tab,event) {
        // if(tab.name == "label1"){
        //   this.columnId = this.qingfengTitleList[0].column_id;
        // }
        // if(tab.name == "label2"){
        //   this.columnId = this.qingfengTitleList[1].column_id;
        // }
        // if(tab.name == "label3"){
        //   this.columnId = this.qingfengTitleList[2].column_id;
        // }
        // if(tab.name == "label4"){
        //   this.columnId = this.qingfengTitleList[3].column_id;
        // }
      },
      tomore(columnId){
        let blank = this.$router.resolve({
          path: '/list/' + columnId,
        });
        window.open(blank.href,'_blank')
      },
      videos(img_name,img_path){
        this.dialogVisible = true
        this.videotitle = img_name
        this.videoUrl = imgPath + img_path
      },
      handleClose(){
        this.dialogVisible = false
        this.videoUrl = ""
        this.videotitle = ""
      },
      details(news_id){
        let blank = this.$router.resolve({
          path: '/list/details/' + news_id,
        });
        window.open(blank.href,'_blank')
      },
    },
  }
</script>

<style>
.el-carousel__item img{width:100%;}
.content_bottom .el-tabs__item{font-size:36px;line-height:56px;height:56px;color:#333333;padding:0 91px;}
.content_bottom .el-tabs__item.is-active{color:#409EFF;}
.content_bottom .el-tabs__nav-wrap::after{background-color:#FFFFFF;}
</style>




// WEBPACK FOOTER //
// src/views/index/index.vue